import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import { Box, IconButton, Popover } from "@mui/material";
import emoji from "emoji-dictionary";
import { useState } from "react";
import { useSelector } from "react-redux";
import EmojiPopover from "./EmojiPopover";
import TaggingTextField from "./TaggingTextField";

const WinWireReplyInput = ({ message, handleSendReply }) => {
  const [inputValue, setInputValue] = useState("");
  const [emojiAnchor, setEmojiAnchor] = useState(null);
  const { tagUserList } = useSelector((state) => state.hub);
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [taggingPopoverOpen, setTaggingPopoverOpen] = useState(false);

  const handleOpenEmojiPopover = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setEmojiAnchor({
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX,
    });
  };

  const handleCloseEmojiPopover = () => {
    setEmojiAnchor(null);
  };

  const handleEmojiSelect = (emojiShortcode) => {
    const emojiNative = emoji.getUnicode(emojiShortcode);
    setInputValue((prev) => prev + emojiNative);
  };

  const handleKeyDown = (event) => {
    if (!taggingPopoverOpen) {
      if (event.key === "Enter") {
        event.preventDefault();

        // sub in the ucl ids for the tags
        let transformedContent = inputValue;
        taggedUsers.forEach((user) => {
          const regex = new RegExp(`@${user.name}`, "g");
          transformedContent = transformedContent.replace(regex, `@[[${user.id}]]`);
        });

        handleSendReply(
          transformedContent,
          taggedUsers.map((user) => user.id)
        );
        setInputValue("");
      }
    }
  };

  const popoverOpen = Boolean(emojiAnchor);
  const id = popoverOpen ? `emoji-popover-${message.id}` : undefined;

  return (
    <Box className="reply-input-bubble" mt={1}>
      <TaggingTextField
        value={inputValue}
        handleInputChange={setInputValue}
        handleKeyDown={handleKeyDown}
        tagUserList={tagUserList}
        taggedUsers={taggedUsers}
        setTaggedUsers={setTaggedUsers}
        setTaggingPopoverOpen={setTaggingPopoverOpen}
      />
      <IconButton
        onClick={handleOpenEmojiPopover}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#ddd9d5",
          fontSize: "1.5rem",
        }}
      >
        <InsertEmoticonIcon />
      </IconButton>
      <Popover
        id={id}
        open={popoverOpen}
        anchorReference="anchorPosition"
        anchorPosition={emojiAnchor}
        onClose={handleCloseEmojiPopover}
        disableRestoreFocus
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          "& .MuiPopover-paper": {
            p: 0,
          },
        }}
      >
        <EmojiPopover
          handleReactionClick={handleEmojiSelect}
          handleCloseEmojiPopover={handleCloseEmojiPopover}
        />
      </Popover>
    </Box>
  );
};

export default WinWireReplyInput;
